import { render, staticRenderFns } from "./FollowupsToolbar.vue?vue&type=template&id=498655d8&scoped=true"
import script from "./FollowupsToolbar.vue?vue&type=script&lang=js"
export * from "./FollowupsToolbar.vue?vue&type=script&lang=js"
import style0 from "./FollowupsToolbar.vue?vue&type=style&index=0&id=498655d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498655d8",
  null
  
)

export default component.exports